function lowerCase(working, command, p) {
  return working.text.toLowerCase();
}

// Meta
lowerCase.key = "lower-case";
lowerCase.title = "Lower Case";
lowerCase.category = "Text Casing";
lowerCase.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/lower-case/";
lowerCase.description = "Convert the working text to lowercase.";
lowerCase.args = [];
lowerCase.parseValidators = [];

export default lowerCase;
